module.exports = __webpack_public_path__ + "agdperfekt.png?31beb937a981c453a1d7c37d7cd33642";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/agdperfekt.png
// module id = 948
// module chunks = 2